import { differenceInMilliseconds } from 'date-fns'

export const compareDates = (a: Date | string, b: Date | string): number => {
  const dateA = new Date(a)
  const dateB = new Date(b)
  return differenceInMilliseconds(dateA, dateB)
}
